Q       = require('q')
_       = require('underscore')
Cookie  = require('js-cookie')
Vue     = require('vue/dist/vue')

appName = 'kgm'

module.exports =
  namespaced: true

  state:
    cookies: {}

  getters:

    getChainedName: (state, getters) -> (name, module) ->
      n = [appName]
      n.push(module) if _.isString(module) && _.size(module) > 0
      n.push(name)
      n.join('-')

    getPlain: (state, getters) -> (name) ->
      Cookie.getJSON(name)

    get: (state, getters) -> (name, module = null) ->
      getters['getPlain'](getters['getChainedName'](name, module))

    isHttpsOnly: (state, getters, rootState, rootGetters) ->
      env = rootGetters['settings/environment']
      env != 'development' && env != 'test'

  mutations:

    setToStore: (state, payload = {}) ->
      Vue.set state.cookies, payload.name, payload.value

    setToCookie: (state, payload = {}) ->
      Cookie.set(payload.name, payload.value, payload.options)

    removeCookie: (state, payload = {}) ->
      Cookie.remove(payload.name, payload.options)

  actions:

    loadPlain: (context, payload = {}) ->
      value = context.getters['getPlain'](payload.name)
      context.commit('setToStore', { name: payload.name, value: value })
      Q(value)

    load: (context, payload = {}) ->
      payload.name  = context.getters['getChainedName'](payload.name, payload.module || null)
      payload.value = context.getters['getPlain'](payload.name, payload.module || null)
      context.commit('setToStore', payload)
      Q(payload.value)

    setPlain: (context, payload = {}) ->
      value   = payload.value || null
      secure  = context.getters['isHttpsOnly'] == true
      context.commit('setToStore', { name: payload.name, value: value })
      context.commit('setToCookie', { name: payload.name, value: value, options: { secure: secure } })
      Q(value)

    removePlain: (context, payload = {}) ->
      secure = context.getters['isHttpsOnly'] == true
      context.commit('removeCookie', { name: payload.name, options: { secure: secure } })
      Q()

    set: (context, payload = {}) ->
      payload.name = context.getters['getChainedName'](payload.name, payload.module || null)
      context.dispatch('setPlain', payload)
      Q(payload.value)

    remove: (context, payload = {}) ->
      payload.name = context.getters['getChainedName'](payload.name, payload.module || null)
      context.dispatch('removePlain', payload)
      Q()



// WEBPACK FOOTER //
// ./assets/js/shared/store/cookie/index.coffee